// import React from "react";
// import { /* Link, */ useNavigate } from "react-router-dom";
// import { /* getAuthUser */ } from "../Authentication/authHelper";


// export const Header = () => {
//     const navigate = useNavigate();

//     return (
//       <>
//         <header>
//           <div className="header-info">
//             <div className="left-part">
//               <a
//                 href="#"
//                 className="site-logo"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   window.dispatchEvent(new Event("openSideMenu"));
//                 }}
//               >
//                 <img src={require("../../assets/images/thcm-logo-red.png")} alt="Homey-FOODS" />
//               </a>
//             </div>
//           <div className="right-part">
//             <h1>Homey-FOODS</h1>
//             <p style={{textAlign: "justify"}}>
//               Throughout human history in all cultures food is an important
//               basis of social bonding. With our increasing human family
//               worldwide. Homey-FOODS offering a venue for all to
//               enjoy unique cuisines, healthy regional foods by many who enjoy
//               cooking and eager to serve variety of foods.{" "}
//             </p>
//             <p style={{textAlign: "justify"}}>
//               <span>
//                 “Restaurant Meals can increase cardiovascular disease
//                 risk”Journal of the Academy of Nutrition and Dietetics-March
//                 2021
//               </span>
//             </p>
//           </div>
//         </div>
//       </header>
//     </>
//   )
// };

import React from "react";
import { useNavigate } from "react-router-dom";
import { getAuthUser, isLoggedIn } from "../Authentication/authHelper";

export const Header = () => {
  const navigate = useNavigate();

  const handleLogoClick = (e) => {
    e.preventDefault();

    // Always prevent navigation to protected home pages if not logged in
    if (!isLoggedIn()) {
      navigate("/", { replace: true }); // landing page
      return;
    }

    const user = getAuthUser();

    // Only allow navigation to home pages if logged in and role matches
    if (user?.role === "MealHost") {
      navigate("/mealhost-home", { replace: true });
      return;
    }

    if (user?.role === "Patron") {
      navigate("/patron-home", { replace: true });
      return;
    }

    // fallback for any other case
    navigate("/", { replace: true });
  };

  return (
    <header>
      <div className="header-info">
        <div className="left-part">
          <a href="#" className="site-logo" onClick={handleLogoClick}>
            <img
              src={require("../../assets/images/thcm-logo-red.png")}
              alt="Homey-FOODS"
            />
          </a>
        </div>

        <div className="right-part">
          <h1>Homey-FOODS</h1>
          <p style={{ textAlign: "justify" }}>
            Throughout human history in all cultures food is an important
            basis of social bonding. With our increasing human family
            worldwide. Homey-FOODS offering a venue for all to enjoy unique
            cuisines, healthy regional foods by many who enjoy cooking and
            eager to serve variety of foods.
          </p>
          <p style={{ textAlign: "justify" }}>
            <span>
              “Restaurant Meals can increase cardiovascular disease risk”
              Journal of the Academy of Nutrition and Dietetics - March 2021
            </span>
          </p>
        </div>
      </div>
    </header>
  );
};
